export default {
  title: {
    id: 'asp_action_bar_problem_declaration_message_step_title',
    defaultMessage: 'Send a message',
  },
}
